import { AxiosResponse } from 'axios';
import querystring from 'querystring';
import { IGeneralFormSubmitReqConfig } from 'src/types/rideSettings/store/types.sagas';

import { getStoreProxyUrl } from '..';
import { ResponseTypes } from '../types';
import { createPayload, postProxy } from '../utilis';
import {
    IRideSettingsRequest,
    IGeneralSettingsResponse,
    SubmitFormResponseData,
} from '../../types/rideSettings/api/types.api';

export const fetchGeneralSettings = <TData>({
    proxyUrl,
    dbUrl,
    ...payload
}: IRideSettingsRequest<TData>): Promise<AxiosResponse<IGeneralSettingsResponse>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Client_General_Settings',
    });

    // FC REQUEST

    return postProxy<IGeneralSettingsResponse>(getStoreProxyUrl(), data);
};

export const fetchSettings = <T, TData>({
    proxyUrl,
    dbUrl,
    endpoint,
    ...payload
}: IRideSettingsRequest<TData>): Promise<AxiosResponse<T>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: endpoint,
    });

    return postProxy<T>(getStoreProxyUrl(), data);
};

export const submitPermManForm = <TData>({
    submitConfigs,
    proxyUrl,
    dbUrl,
    ...payload
}: IRideSettingsRequest<TData>): Promise<AxiosResponse<SubmitFormResponseData>> => {
    const { token, clientCode } = payload;

    if (!submitConfigs) {
        throw new Error('Missing submitConfigs');
    }

    if (!submitConfigs.endpoint) {
        throw new Error('Missing endpoint');
    }

    const rawData = submitConfigs.stringify
        ? {
              [submitConfigs.dataParamName]: JSON.stringify(payload.data),
          }
        : payload.data;

    const processedPayload = { token, clientCode, ...rawData };

    const data = querystring.stringify({
        ...createPayload(processedPayload),
        webservice: submitConfigs.endpoint,
    });

    return postProxy<SubmitFormResponseData>(getStoreProxyUrl(), data);
};

export const generalSettingsSubmitForm = ({
    proxyUrl,
    dbUrl,
    ...payload
}: IGeneralFormSubmitReqConfig): Promise<AxiosResponse<SubmitFormResponseData>> => {
    const params = querystring.stringify({
        ...createPayload(payload.params),
        webservice: 'ws_MyWayStudio_Set_Client_General_Settings',
    });

    // FC REQUEST

    return postProxy<SubmitFormResponseData>(getStoreProxyUrl(), params);
};